import { createAsyncThunk } from '@reduxjs/toolkit';

import { editorialSectionsService } from '@/services';
import { handleThunkApiError } from '@/utils';

export const getEditorialSections = createAsyncThunk(
  'editorial/getEditorialSections',
  handleThunkApiError(editorialSectionsService.getEditorialSections),
);
